import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { loginGuard } from './shared/guard/login.guard';
import { authGuard } from './shared/guard/auth.guard';
import { accountStatusGuard } from './shared/guard/account-status.guard';



@NgModule({
  imports: [
    RouterModule.forRoot([

      // Specific routes FIRST — they must be matched before the empty-path ('') catch-all modules
      // below. Angular loads an empty-path lazy module just to check its children on every
      // navigation, so keeping these on top stops the user-accounts routes / MainModule loading on
      // routes like /guest-creative-flow or /web-scrapper (guests never load them).
      {
        path: 'web-scrapper',
        loadChildren: () => import('../app/modules/main/web-scrapper/web-scrapper.routes').then((m) => m.WEB_SCRAPPER_ROUTES),
        // canActivate: [authGuard]
      },

      {
        path: 'design-system',
        loadChildren: () =>
          import('../app/shared/design-system/design-system.module').then((m) => m.DesignSystemModule), //Lazy load account module
      },

      {
        path: 'user-accounts/email-verification/:code',
        loadComponent: () => import('./modules/main/user-accounts/email-verification/email-verification.component').then(m => m.EmailVerificationComponent),
      },
      {
        path: 'reset-password/:code',
        loadComponent: () => import('./modules/main/user-accounts/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
      },

      {
        path: 'microservice-tester',
        loadChildren: () =>
          import('../app/modules/external/microservice-tester/microservice-tester.module').then(
            (m) => m.MicroserviceTesterModule,
          ),
      },
      {
        path: 'google-auth',
        loadChildren: () => import('../app/modules/external/google-auth/google-auth-routing.module').then((m) => m.GoogleAuthRoutingModule),
      },
      {
        path: 'facebook-auth',
        loadChildren: () => import('../app/modules/external/facebook-auth/facebook-auth-routing.module').then((m) => m.FacebookAuthRoutingModule),
      },
      {
        path: 'shopify-auth',
        loadChildren: () => import('../app/modules/external/shopify-auth/shopify-auth-routing.module').then((m) => m.ShopifyAuthRoutingModule),
      },

      {
        path: 'external/xoopah-subscription',
        loadChildren: () => import('../app/modules/external/xoopah-subscription/xoopah-subscription.module').then((m) => m.XoopahSubscriptionModule),
      },

      // Public shared-creative page. No guard: anyone with the link can view it.
      {
        path: 'share/:code',
        loadComponent: () => import('./modules/external/shared-creative/shared-creative.component').then((m) => m.SharedCreativeComponent),
      },

      {
        path: 'guest-creative-flow',
        loadChildren: () => import('./modules/external/guest-creative-flow/guest-creative-flow.routes').then((m) => m.GUEST_CREATIVE_FLOW_ROUTES),
      },

      // Empty-path ('') catch-alls LAST.
      {
        path: '',
        loadChildren: () => import('../app/modules/main/user-accounts/user-accounts.routes').then((m) => m.USER_ACCOUNT_ROUTES),
      },
      {
        path: '',
        loadChildren: () => import('../app/modules/main/main.module').then((m) => m.MainModule),
      },

      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
      },
    ]),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
